import { render } from "./DevicesPage3d.vue?vue&type=template&id=60246e31&scoped=true"
import script from "./DevicesPage3d.vue?vue&type=script&lang=js"
export * from "./DevicesPage3d.vue?vue&type=script&lang=js"

import "./DevicesPage3d.vue?vue&type=style&index=0&id=60246e31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60246e31"]])

export default __exports__